export enum FeedbackView {
    Faces = 'faces',
    Stars = 'stars'
}